import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "8",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.017 7.398a.79.79 0 0 1-.563-.234L.139 1.85A.797.797 0 0 1 1.266.754l4.751 4.72L10.77.754a.797.797 0 0 1 1.127 1.063L6.58 7.132a.79.79 0 0 1-.564.266" }, null, -1)
  ]))]))
}
export default { render: render }